import TextInput from "../../../common/TextInput";

export default function ReviewStep({
  poNumView,
  money,
  grandTotal,
  selectedProjectId,
  setSelectedProjectId,
  PROJECTS,
  customProject,
  setCustomProject,
  notes,
  setNotes,
}) {
  return (
    <div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-xl border border-slate-200 p-3.5">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">PO Number</p>
          <p className="mt-1 text-2xl font-bold text-slate-900">{poNumView ?? "—"}</p>
        </div>
        <div className="flex flex-col justify-center rounded-xl border border-brand-200 bg-brand-50/50 p-3.5">
          <span className="text-[10px] font-semibold uppercase tracking-wide text-brand-600">Grand Total</span>
          <span className="text-2xl font-bold text-slate-900">{money(grandTotal)}</span>
        </div>
      </div>

      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <div>
          <label className="mb-1 block text-[12px] font-medium text-slate-600">Project</label>
          <select
            value={selectedProjectId}
            onChange={(e) => setSelectedProjectId(e.target.value)}
            className="w-full rounded-lg border border-slate-200 px-3 py-2 text-[13px] outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
          >
            <option value="">Select project</option>
            {PROJECTS.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
                {p.id !== "custom" ? ` (${p.id})` : ""}
              </option>
            ))}
          </select>
        </div>
        {selectedProjectId === "custom" && (
          <>
            <TextInput
              label="Project Name"
              value={customProject.name}
              onChange={(e) => setCustomProject((p) => ({ ...p, name: e.target.value }))}
            />
            <TextInput
              label="Project Code"
              value={customProject.id}
              onChange={(e) => setCustomProject((p) => ({ ...p, id: e.target.value }))}
            />
          </>
        )}
      </div>

      <div className="mt-3">
        <TextInput label="Notes" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Additional notes" />
      </div>
    </div>
  );
}